import { render, staticRenderFns } from "./AmendmentHistory.vue?vue&type=template&id=3589b2e8&lang=true"
import script from "./AmendmentHistory.vue?vue&type=script&lang=js"
export * from "./AmendmentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3589b2e8')) {
      api.createRecord('3589b2e8', component.options)
    } else {
      api.reload('3589b2e8', component.options)
    }
    module.hot.accept("./AmendmentHistory.vue?vue&type=template&id=3589b2e8&lang=true", function () {
      api.rerender('3589b2e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/components/AmendmentHistory.vue"
export default component.exports